import { useState } from 'react';

export const useForceRender = () => {
	const [state, setState] = useState(0);

	return () => {
		setState(state + 1);
	};
};
